export default __webpack_public_path__ + "static/gather-c7997acda104e68eee38301cd77f503d.png";